import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import TableChartIcon from "@mui/icons-material/TableChart";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PeopleIcon from "@mui/icons-material/People";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { LightTooltip } from "../../../kit/LightToolTip";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateSideNavFlag } from "../../../redux/slice/harborSlice";
import { useTheme } from "@mui/styles";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from '@mui/icons-material/School';
import StorageIcon from "@mui/icons-material/Storage";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const navItems = [
    {
      to: "/harbor",
      icon: <DashboardIcon sx={{ fontSize: 20 }} />,
      label: "Dashboard",
      roles: ["admin", "reviewer", "approver", "super_user"],
    },
  {
    to: "/harbor/reviewer",
    icon: <TableChartIcon sx={{ fontSize: 20 }} />,
    label: "Review Data",
    roles: ["reviewer"],
  },
  {
    to: "/harbor/approver",
    icon: <VerifiedUserIcon sx={{ fontSize: 20 }} />,
    label: "Approvals",
    roles: ["approver"],
  },
  {
    to: "/harbor/submissions",
    icon: <AssignmentTurnedInIcon sx={{ fontSize: 20 }} />,
    label: "My Submissions",
    roles: ["reviewer"],
  },
  {
    to: "/harbor/access-management",
    icon: <PeopleIcon sx={{ fontSize: 20 }} />,
    label: "User Management",
    roles: ["admin","super_user"],
  },
  {
    to: "/harbor/function-access",
    icon: <AccountBoxIcon sx={{ fontSize: 20 }} />,
    label: "Function Access",
    roles: ["admin", "reviewer", "approver", "super_user"],
  },
  {
    to: "/harbor/knowledge-hub",
    icon: <SchoolIcon sx={{ fontSize: 20 }} />,
    label: "Knowledge Hub",
    roles: ["admin", "reviewer", "approver", "super_user"],
  },
  {
    to: "/harbor/ssot",
    icon: <StorageIcon sx={{ fontSize: 20 }} />,
    label: "SSOT",
    roles: ["admin", "reviewer", "approver", "super_user"],
  },
];

export default function Sidebar() {
  const visible = navItems;
  const sideNavFlag = useSelector((state) => state.harbor.sideNavFlag);
  const harborRole = useSelector((state) => state.auth.metadata?.harbor?.role);
  const dispatch = useDispatch();
  const theme = useTheme();

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    fontSize: "0.875rem",
    fontWeight: 500,
    textDecoration: "none",
    color: theme.palette.icons.main,
    transition: "background 0.15s",
  };

  const activeLinkStyle = {
    ...linkStyle,
    backgroundColor: theme.palette.harbor.sideNav.iconBackground,
    color: theme.palette.harbor.sideNav.iconColor,
  };

  const hoverStyle = theme.palette.harbor.sideNav.hoverColor;
  return (
    <Box
      component="aside"
      sx={{
        width: sideNavFlag ? 240 : 72,
        transition: "width 300ms ease-in-out",
        bgcolor: theme.palette.harbor.sideNav.background,
        borderRight: `1px solid ${theme.palette.harbor.sideNav.border}`,
        boxShadow: theme.palette.harbor.sideNav.boxShadow,
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          right: "-15px",
          top: "15px",
          background: "black",
          borderRadius: "50%",
          display: "flex",
          padding: "6px",
          cursor: "pointer",
          transition: "all 300ms ease",
        }}
        onClick={() => {
          dispatch(updateSideNavFlag(!sideNavFlag));
        }}
      >
        {sideNavFlag ? (
          <ArrowBackIosIcon
            sx={{
              color: "white",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        ) : (
          <ArrowForwardIosIcon sx={{ color: "white", fontSize: "16px" }} />
        )}
      </Box>
      <Box component="nav" sx={{ flex: 1, py: 2, px: 1.5, marginTop: "40px" }}>
        {visible
          .filter((item) => item.roles.includes(harborRole))
          .map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/harbor"}
              style={({ isActive }) => (isActive ? activeLinkStyle : linkStyle)}
              onMouseEnter={(e) => {
                if (!e.currentTarget.classList.contains("active")) {
                  e.currentTarget.style.backgroundColor = hoverStyle;
                }
              }}
              onMouseLeave={(e) => {
                const isActive =
                  e.currentTarget.getAttribute("aria-current") === "page";
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = "transparent";
                }
              }}
            >
              {/* {item.icon} */}

              <LightTooltip
                title={!sideNavFlag ? item.label : ""}
                placement="right"
                arrow
                disableHoverListener={sideNavFlag}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "24px",
                    cursor: "pointer",
                  }}
                >
                  {item.icon}
                </Box>
              </LightTooltip>

              <Box
                sx={{
                  whiteSpace: "nowrap",
                  opacity: sideNavFlag ? 1 : 0,
                  transform: sideNavFlag ? "translateX(0)" : "translateX(-8px)",
                  pointerEvents: sideNavFlag ? "auto" : "none",
                  transition: "opacity 200ms ease, transform 200ms ease",
                }}
              >
                {item.label}
              </Box>
            </NavLink>
          ))}
      </Box>
    </Box>
  );
}